import { useCallback } from 'react';

import { useTrackException } from 'presentation/events/hooks/useTrackException';
import { TrackSelectItemProps } from './types';
import { useTrackSelectItemGA4 } from './useTrackSelectItemGA4';
import { buildChatbotEventParams } from 'presentation/events/hooks/useTrackDibot';

export const useTrackSelectItem = () => {
	const trackException = useTrackException();
	const sendGA4Event = useTrackSelectItemGA4();

	return useCallback(
		({ product, isEmarsys, categories, quantity = 1, isChatbotEvent, plpBadges }: TrackSelectItemProps) => {
			try {
				const chatbotEventParams = buildChatbotEventParams({
					isChatbotEvent,
				});

				sendGA4Event({ product, isEmarsys, categories, quantity, chatbotEventParams, plpBadges });
			} catch (e) {
				console.error('Error sending select item event', e);
				trackException(e);
			}
		},
		[sendGA4Event, trackException]
	);
};
